// https://stackoverflow.com/questions/39879680/example-of-setting-webpack-public-path-at-runtime
// https://stackoverflow.com/a/51245153
// @ts-ignore
__webpack_public_path__ = window.PUBLIC_PATH; // <- rename to something more appropriate
